import React from 'react';
import PropTypes from 'prop-types';

const STATUS_ORDER = ['PENDING', 'IN_PROGRESS', 'COMPLETED'];

const STATUS_COLORS = {
    PENDING: '#C23A2F',
    IN_PROGRESS: '#D9A441',
    COMPLETED: '#3A8E77',
};

class StatusSlider extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }
    render() {
        const { value } = this.props;
        const activeIndex = STATUS_ORDER.indexOf(value);
        const color = STATUS_COLORS[value];

        const leftFlex = [0, 1, 2][activeIndex];
        const rightFlex = [2, 1, 0][activeIndex];

        return (
            <div style={{ display: 'flex', alignItems: 'center', width: 240 }}>
                <div
                    style={{
                        flex: leftFlex,
                        height: 2,
                        background: color,
                        transition: 'flex 0.6s',
                    }}
                />
                <div
                    style={{
                        width: 16,
                        height: 16,
                        borderRadius: '50%',
                        background: color,
                    }}
                />
                <div
                    style={{
                        flex: rightFlex,
                        height: 2,
                        background: color,
                        transition: 'flex 0.3s',
                    }}
                />
            </div>
        );
    }
}

StatusSlider.propTypes = {
    value: PropTypes.oneOf(['PENDING', 'IN_PROGRESS', 'COMPLETED']).isRequired,
};

export default StatusSlider;
